import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import { initAnalytics, trackEvent } from "./lib/analytics";
import Home from "./pages/Home";
import About from "./pages/About";
import Team from "./pages/Team";
import Services from "./pages/Services";
import ServicePage from "./pages/ServicePage";
import Start from "./pages/Start";
import FAQ from "./pages/FAQ";
import Insurance from "./pages/Insurance";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";

const PAGE_TITLES = {
  "/": "Thrive Pediatric Therapy | Nassau, Bahamas",
  "/about": "About Us | Thrive Pediatric Therapy",
  "/services": "Our Services | Thrive Pediatric Therapy",
  "/team": "Our Team | Thrive Pediatric Therapy",
  "/start": "Not Sure Where to Start? | Thrive Pediatric Therapy",
  "/faq": "FAQ | Thrive Pediatric Therapy",
  "/insurance": "Using Insurance | Thrive Pediatric Therapy",
  "/testimonials": "Testimonials | Thrive Pediatric Therapy",
  "/contact": "Contact Us | Thrive Pediatric Therapy",
};

const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    const path = location.pathname;
    if (PAGE_TITLES[path] && !document.title.startsWith("Thrive Pediatric Therapy | Physio")) {
      document.title = PAGE_TITLES[path];
    }
    trackEvent("page_view", {
      page_path: path,
      device_type: window.innerWidth < 768 ? "mobile" : "desktop",
    });
    if (path.startsWith("/services/")) {
      trackEvent("service_page_view", { service: path.split("/")[2] });
    }
  }, [location.pathname]);

  return null;
};

function App() {
  useEffect(() => {
    initAnalytics();
    const lenis = new Lenis({ autoRaf: true });
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <RouteTracker />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/team" element={<Team />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/start" element={<Start />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/insurance" element={<Insurance />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
